<app-modal-shell [title]="title" size="md" [closeDisabled]="saving || deleting" (closed)="close()">
  <div icon class="header-icon" [class.danger]="confirmingDelete">
    <i class="bi" [class]="confirmingDelete ? 'bi-exclamation-triangle-fill' : 'bi-diagram-3-fill'"></i>
  </div>

  @if (loading) {
    <div class="loading-panel">
      <app-loader />
    </div>
  } @else if (confirmingDelete) {
    <div class="confirm-panel">
      <p class="confirm-text">
        You're about to remove the MDM database configuration for this tenant. MDM will lose its
        connection until a new configuration is created. This action can't be undone.
      </p>
    </div>
  } @else {
    <form [formGroup]="form" class="mdm-form">
      <div class="form-section">
        <h6 class="section-title">Connection</h6>
        <div class="form-group">
          <label for="host">Host</label>
          <div class="input-with-icon">
            <i class="bi bi-hdd-network"></i>
            <input id="host" type="text" formControlName="host" placeholder="myserver.database.windows.net" />
          </div>
          @if (form.controls['host'].invalid && form.controls['host'].touched) {
            <span class="field-error">Host is required.</span>
          }
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="db">Database</label>
            <div class="input-with-icon">
              <i class="bi bi-database"></i>
              <input id="db" type="text" formControlName="db" placeholder="mdm_platinum" />
            </div>
            @if (form.controls['db'].invalid && form.controls['db'].touched) {
              <span class="field-error">Database is required.</span>
            }
          </div>
          <div class="form-group">
            <label for="user">Username</label>
            <div class="input-with-icon">
              <i class="bi bi-person"></i>
              <input id="user" type="text" formControlName="user" placeholder="sa" />
            </div>
            @if (form.controls['user'].invalid && form.controls['user'].touched) {
              <span class="field-error">Username is required.</span>
            }
          </div>
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <div class="input-with-icon input-with-action">
            <i class="bi bi-lock"></i>
            <input id="password" [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="••••••••" />
            <button type="button" class="reveal-btn" (click)="showPassword = !showPassword">
              <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
            </button>
          </div>
          @if (form.controls['password'].invalid && form.controls['password'].touched) {
            <span class="field-error">Password is required.</span>
          }
        </div>
      </div>

      <div class="form-section optional">
        <h6 class="section-title">Advanced <span class="optional-tag">Defaults provided</span></h6>
        <div class="form-row">
          <div class="form-group">
            <label for="port">Port</label>
            <div class="input-with-icon">
              <i class="bi bi-diagram-2"></i>
              <input id="port" type="number" formControlName="port" placeholder="1433" />
            </div>
            @if (form.controls['port'].invalid && form.controls['port'].touched) {
              <span class="field-error">A valid port is required.</span>
            }
          </div>
          <div class="form-group">
            <label for="driver">Driver</label>
            <div class="input-with-icon">
              <i class="bi bi-gear"></i>
              <input id="driver" type="text" formControlName="driver" placeholder="{ODBC Driver 17 for SQL Server}" />
            </div>
            @if (form.controls['driver'].invalid && form.controls['driver'].touched) {
              <span class="field-error">Driver is required.</span>
            }
          </div>
        </div>
      </div>
    </form>
  }

  <div footer class="footer-row">
    @if (confirmingDelete) {
      <button type="button" class="cancel-btn" [disabled]="deleting" (click)="cancelDelete()">Cancel</button>
      <button type="button" class="danger-btn" [disabled]="deleting" (click)="runDelete()">
        @if (deleting) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span>Removing…</span>
        } @else {
          <i class="bi bi-trash"></i>
          <span>Remove Configuration</span>
        }
      </button>
    } @else {
      <div class="footer-left">
        @if (isEditing && !loading) {
          <button type="button" class="text-danger-btn" [disabled]="saving" (click)="confirmDelete()">
            <i class="bi bi-trash"></i>
            <span>Remove</span>
          </button>
        }
      </div>
      <div class="footer-right">
        <button type="button" class="cancel-btn" [disabled]="saving" (click)="close()">Cancel</button>
        @if (!loading) {
          <button type="button" class="submit-btn" [disabled]="saving" (click)="submit()">
            @if (saving) {
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span>Saving…</span>
            } @else {
              <i class="bi bi-check-lg"></i>
              <span>{{ isEditing ? 'Save Changes' : 'Save Configuration' }}</span>
            }
          </button>
        }
      </div>
    }
  </div>
</app-modal-shell>
